import { useState } from 'react';
import { MAKE_MODELS } from '../data/siteData';

export function usePartsSearch(initialValues = {}) {
  const [year, setYear] = useState(initialValues.year || '');
  const [make, setMake] = useState(initialValues.make || '');
  const [model, setModel] = useState(initialValues.model || '');
  const [category, setCategory] = useState(initialValues.category || '');
  const [partName, setPartName] = useState(initialValues.partName || '');

  const makes = Object.keys(MAKE_MODELS).sort();
  const models = make && MAKE_MODELS[make] ? MAKE_MODELS[make] : [];

  const handleMakeChange = (val) => {
    setMake(val);
    setModel('');
  };

  const buildQuery = () => {
    return [year, make, model, category !== 'All Parts' ? category : '', partName]
      .filter(Boolean)
      .join(' ')
      .trim();
  };

  const search = () => {
    const query = buildQuery();
    if (!query) return false;
    const url = `https://www.carparts.com/search?q=${encodeURIComponent(query)}`;
    window.open(url, '_blank', 'noopener noreferrer');
    return true;
  };

  const searchByPartName = (name) => {
    const q = name || partName;
    if (!q.trim()) return false;
    const url = `https://www.carparts.com/search?q=${encodeURIComponent(q.trim())}`;
    window.open(url, '_blank', 'noopener noreferrer');
    return true;
  };

  return {
    year, setYear,
    make, setMake: handleMakeChange,
    model, setModel,
    category, setCategory,
    partName, setPartName,
    makes, models,
    search, searchByPartName,
    hasQuery: !!buildQuery(),
  };
}
